import { render, staticRenderFns } from "./DashboardPieEventsConfigDialog.vue?vue&type=template&id=088565e6&scoped=true"
import script from "./DashboardPieEventsConfigDialog.vue?vue&type=script&lang=js"
export * from "./DashboardPieEventsConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./DashboardPieEventsConfigDialog.vue?vue&type=style&index=0&id=088565e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088565e6",
  null
  
)

export default component.exports